import EventEmitter from 'eventemitter3';

export default class Store extends EventEmitter {
  all() {
    throw "not implemented";
  }

  on(events, callback) {
    return events.split(" ").map((event) => super.on(event, callback));
  }

  off(events, callback) {
    return events.split(" ").map((event) => super.off(event, callback));
  }
}
